import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import APIserver from '../../../../api/axiosConfig';
import AlertsFacturas from '../../facturas/Utils/AlertsFacturas';

const EditarDevModal = ({ show, handleClose, devolucion }) => {
    const [formData, setFormData] = useState({
        numeroFactura: devolucion?.numeroFactura || '',
        cliente: devolucion?.cliente || '',
        detalle: devolucion?.detalle || '',
        fecha: devolucion?.fecha || '',
        banco: devolucion?.banco || '',
        monto: devolucion?.monto || ''
    });
    const [bancos, setBancos] = useState([]);
    const [selectedBanco, setSelectedBanco] = useState(null);
    const [montoMaximo, setMontoMaximo] = useState(0);

    // Fetch de bancos
    const fetchBancos = async () => {
        try {
            const response = await APIserver.get(`/api/pagosrecibidos/mostrar/bancos`);
            if (response.data && Array.isArray(response.data.bancos)) {
                setBancos(response.data.bancos.map(banco => ({ value: banco.idBanco, label: banco.nomBanco })));
            } else {
                setBancos([]);
            }
        } catch (error) {
            console.error('Error al obtener los bancos:', error);
            setBancos([]);
        }
    };

    useEffect(() => {
        fetchBancos();
    }, []);

    useEffect(() => {
        if (devolucion) {
            setFormData({
                numeroFactura: devolucion.numFacv || '',
                cliente: devolucion.nomCliente || '',
                detalle: devolucion.detalle || '',
                fecha: devolucion.fecha ? new Date(devolucion.fecha).toISOString().split('T')[0] : '',
                banco: devolucion.nomBanco || '',
                monto: devolucion.monto || '',
            });

            // Seleccionar automáticamente el banco correspondiente
            setSelectedBanco(devolucion.nomBanco ? bancos.find(b => b.label === devolucion.nomBanco) : null);
        }
    }, [devolucion, bancos]);

    const handleBancoChange = (selectedOption) => {
        setSelectedBanco(selectedOption);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;



        setFormData({
            ...formData,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedBanco) {
            AlertsFacturas.showErrorMessage('Debe seleccionar un banco.');
            return;
        }

        const updatedDevolucion = {
            idDevolucion: devolucion.idDevolucion,
            numFacV: formData.numeroFactura,
            detalle: formData.detalle,
            monto: parseFloat(formData.monto),
            idBanco: selectedBanco.value,
            fecha: formData.fecha
        };

        try {
            const response = await APIserver.put(`/api/devoluciones/editar`, updatedDevolucion);
            if (response.status === 200) {
                AlertsFacturas.showUpdateSuccessMessage('Devolución actualizada correctamente.');
                handleClose();
            } else {
                AlertsFacturas.showErrorMessage('Error al actualizar la devolución.');
            }
        } catch (error) {
            console.error('Error al actualizar la devolución:', error);
            AlertsFacturas.showErrorMessage('Ocurrió un error al intentar actualizar la devolución.');
        }
    };

    const handleFacturaBlur = () => {
        const { numeroFactura } = formData;
        if (numeroFactura && numeroFactura.trim() !== '') {
            fetchClienteByFactura(numeroFactura);
        }
    };

    const fetchClienteByFactura = async (numeroFactura) => {
        if (numeroFactura.trim() !== '') {
            try {
                const response = await APIserver.get(`/api/pagosrecibidos/nombreCliente/${numeroFactura}`);
                const { nombreCliente, numFacV, totalFacV, pagadoFacV } = response.data;

                if (totalFacV === undefined || pagadoFacV === undefined) {
                    AlertsFacturas.showErrorMessage('Datos de factura incompletos.');
                    return;
                }

                setFormData(prevFormData => ({
                    ...prevFormData,
                    cliente: nombreCliente,
                    numeroFactura: numFacV
                }));
                setMontoMaximo(totalFacV - pagadoFacV);
            } catch (error) {
                AlertsFacturas.showErrorMessage('Factura no encontrada.');
            }
        }
    };

    return (
        <Modal size="lg" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Editar Devolución</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col>
                            <Form.Group controlId="formNumeroFactura" className="m-3 mt-0">
                                <Form.Label>Número de Factura</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="numeroFactura"
                                    value={formData.numeroFactura}
                                    onChange={handleChange}
                                    onBlur={handleFacturaBlur}
                                    required
                                    readOnly
                                />
                            </Form.Group>

                            <Form.Group controlId="formCliente" className="m-3">
                                <Form.Label>Cliente</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="cliente"
                                    value={formData.cliente}
                                    onChange={handleChange}
                                    readOnly
                                />
                            </Form.Group>

                            <Form.Group controlId="formDetalle" className="m-3">
                                <Form.Label>Detalle</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="detalle"
                                    value={formData.detalle}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="formFecha" className="m-3">
                                <Form.Label>Fecha</Form.Label>
                                <Form.Control
                                    type="date"
                                    name="fecha"
                                    value={formData.fecha}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group controlId="formBanco" className="m-3">
                                <Form.Label>Banco</Form.Label>
                                <Select
                                    placeholder="Seleccione el Banco"
                                    options={bancos}
                                    value={selectedBanco}
                                    onChange={handleBancoChange}
                                    required
                                />
                            </Form.Group>

                            <Form.Group controlId="formMonto" className="m-3">
                                <Form.Label>Monto</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="monto"
                                    value={formData.monto}
                                    onChange={handleChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Modal.Footer>
                        <Button variant='dark' onClick={handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="danger" type="submit">
                            Guardar
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default EditarDevModal;
